// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"4089e804","453":"50912e88"}[chunkId] + ".chunk.js";
};